module.exports = __webpack_public_path__ + "img/spongaBanner.c2688f5e.png";